module.exports = __webpack_public_path__ + "kubernetes.icon.c1170.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/logo/kubernetes.icon.svg
// module id = 1461
// module chunks = 0